import { mediumFont, regularFont, theme } from "../../utils/styles";

const compatibilityStyles = {
  mainContainer: {
    display: "flex",
    justifyContent: "center",
    mx: 5,
    [theme.breakpoints.down("sm")]: {
      mx: 2,
    },
  },
  mainBox: {
    p: 1,
    borderRadius: "28px",
    height: "calc(100vh - 184px)",
    background: "rgba(255, 255, 255, 0.07)",
    backdropFilter: "blur(24px)",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    boxShadow: "0 4px 30px rgba(0, 0, 0, 0.1)",
    my: 3,
    maxWidth: "1750px",
    width: "100%",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 204px)",
    },
    [theme.breakpoints.down("md")]: {
      my: 2,
      height: "calc(100vh - 209px)",
    },
    [theme.breakpoints.down("sm")]: {
      my: 3,
    },
  },
  subBox: {
    p: 3,
    pt: 1.5,
    height: "calc(100vh - 222px)",
    borderRadius: "20px",
    border: "1px solid rgba(255, 255, 255, 0.14)",
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 242px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 247px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 229px)",
      p: 1,
    },
  },
  scrollStyle: {
    height: "calc(100vh - 200px)",
    overflowY: "auto",
    overflowX: "hidden",
    "&::-webkit-scrollbar": {
      width: "5px",
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: "10px",
      border: "1px solid #FFFFFF",
      background: "#282945",
    },
    [theme.breakpoints.down(1311)]: {
      height: "calc(100vh - 220px)",
    },
    [theme.breakpoints.down("md")]: {
      height: "calc(100vh - 235px)",
    },
    [theme.breakpoints.down("sm")]: {
      height: "calc(100vh - 222px)",
    },
  },
  italicTypo: {
    color: "#FFF",
    textAlign: "center",
    fontFamily: mediumFont.fontFamily,
    fontWeight: mediumFont.fontWeight,
    fontSize: "45px",
    fontStyle: "normal",
    lineHeight: "normal",
    letterSpacing: "0.77px",
    textTransform: "uppercase",
    margin: "0 auto",
    [theme.breakpoints.down("sm")]: {
      fontSize: "20px",
    },
  },
  autoCompleteWrapper: {
    display: "flex",
    gap: 3,
    flexDirection: {
      xs: "column",
      sm: "row",
    },
    width: "100%",
    maxWidth: "800px",
    margin: "0 auto",
  },
  autoComplete: {
    flex: 1,
    "& .MuiAutocomplete-input": {
      color: "#FFFFFF",
    },
    "& .MuiInputBase-root": {
      borderRadius: "10px",
      background: "rgba(255, 255, 255, 0.05)",
      backdropFilter: "blur(5.5px)",
      border: "1px solid rgba(255, 255, 255, 0.2)",
      transition: "border-color 0.2s ease",
      "&:hover": {
        borderColor: "rgba(255, 255, 255, 0.3)",
      },
      "&.Mui-focused": {
        borderColor: "rgba(255, 255, 255, 0.4)",
      },
    },
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
    "& .MuiAutocomplete-endAdornment": {
      "& .MuiSvgIcon-root": {
        color: "#FFFFFF",
      },
    },
    "& .MuiAutocomplete-clearIndicator": {
      color: "#FFFFFF",
    },
  },
  autoCompleteLabel: {
    color: "#FFFFFF",
    opacity: 0.7,
    marginBottom: "8px",
    fontSize: "14px",
  },
  namesHeader: {
    my: 3,
  },
  personName: {
    color: "#FFF",
    fontSize: "22px",
    letterSpacing: "1px",
    ...regularFont,
  },
  vsText: {
    color: "#FFD700",
    fontSize: "18px",
    px: 1,
    ...mediumFont,
  },
  comparisonRow: {
    mb: 2,
    p: 2,
    borderRadius: "12px",
    background: "rgba(255,255,255,0.07)",
    border: "1px solid rgba(255,255,255,0.12)",
    boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
  },
  yesNoBox: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    height: "40px",
    borderRadius: "8px",
    background: "rgba(255,255,255,0.12)",
    boxShadow: "0 1px 6px rgba(0,0,0,0.04)",
  },
} as const;

export default compatibilityStyles;
